import Controller from "./editableCheckbox.controller";
import template from "./editableCheckbox.html";

const editableCheckbox = {
  template,
  controller: Controller,
  bindings: {
    selected: "=",
    title: "@",
    name: "@",
    eventName: "<",
    hideEdit: "<",
    isRequired: "<",
    permissionName: "@",
    resourceMethod: "@",
    resourceMethodName: "@",
    extraParams: "<",
    checkedByDefault: "<",
  },
};

export default editableCheckbox;



// WEBPACK FOOTER //
// ./src/components/editableCheckbox/editableCheckbox.component.js